var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"align-center layout px-4 pt-2 app--page-header",attrs:{"row":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }